import React from 'react';

// Делает ссылки (http/https) в тексте кликабельными, сохраняя переносы строк.
const URL_RE = /(https?:\/\/[^\s]+)/g;
const isUrl = s => /^https?:\/\//.test(s);

export default function Linkify({ text }) {
  const parts = String(text ?? '').split(URL_RE);
  return (
    <>
      {parts.map((p, i) =>
        isUrl(p)
          ? <a key={i} href={p} target="_blank" rel="noopener noreferrer"
               onClick={e => e.stopPropagation()}
               style={{ color: 'var(--accent)', wordBreak: 'break-all' }}>{p}</a>
          : p
      )}
    </>
  );
}
